export const iconForTaskStatus = taskStatus => {
  let iconName
  switch (taskStatus) {
    case 1:
      iconName = 'active'
      break
    case 2:
      iconName = 'done'
      break
    case 3:
      iconName = 'switch'
      break
    case 4:
      iconName = 'continue'
      break
    default:
      iconName = 'done'
  }
  return iconName
}



// WEBPACK FOOTER //
// ./src/utils/icon.js